import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { BookState } from '@/store/types/book.state';

export const actions: ActionTree<BookState, RootState> = {

}